import { Link } from "react-router-dom";
import { Grid3x3, PackagePlus, RotateCcw, Boxes, Factory, GitCompare } from "lucide-react";
import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";

const CATEGORIES = [
  { id: "by-category", Icon: Grid3x3, title: "By Category", body: "Browse devices organized by type — scanners, tablets, mobile computers, and more." },
  { id: "new-devices", Icon: PackagePlus, title: "New Devices", body: "Factory-new hardware across every major device category." },
  { id: "certified-refurbished", Icon: RotateCcw, title: "Certified Refurbished", body: "Inspected, tested, and certified units at a lower total cost." },
  { id: "bundles-kits", Icon: Boxes, title: "Device Bundles & Kits", body: "Pre-configured bundles for common deployment scenarios." },
  { id: "oem-devices", Icon: Factory, title: "OEM Devices", body: "Direct access to leading device manufacturers, vendor-neutral." },
];

const Marketplace = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.marketplace");
  return (
    <div>
      <PageHeader
        eyebrow={<span className="dw-badge">{h.eyebrow}</span>}
        title={h.title}
        description={h.description}
      />

      <div className="max-w-5xl mx-auto px-5 py-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {CATEGORIES.map(({ id, Icon, title, body }) => (
          <div key={id} id={id} className="dw-card scroll-mt-24">
            <Icon size={28} strokeWidth={1.5} style={{ color: "var(--dw-accent)" }} />
            <h3 className="pt-3 text-base">{title}</h3>
            <p className="dw-mini pt-1 text-sm">{body}</p>
          </div>
        ))}

        <div className="dw-card flex flex-col justify-between">
          <div>
            <GitCompare size={28} strokeWidth={1.5} style={{ color: "var(--dw-accent)" }} />
            <h3 className="pt-3 text-base">Not sure where to start?</h3>
            <p className="dw-mini pt-1 text-sm">Answer a few quick questions and we'll point you to the right device category.</p>
          </div>
          <Link to="/solutions/deviceworks/marketplace/compare" className="dw-btn-outline mt-4 self-start">Compare Devices</Link>
        </div>
      </div>
    </div>
  );
};

export default Marketplace;
